import { Component, Input } from '@angular/core';
import { SummaryData } from 'src/app/pages/new-service/interfaces/SummaryData';

@Component({
  selector: 'app-document-info',
  templateUrl: './document-info.component.html',
  styleUrls: ['./document-info.component.scss'],
})
export class DocumentInfoComponent {
  @Input() summaryData: SummaryData = {} as SummaryData;
}
